<template>
	<v-container>
		<div v-show="multipleFilter">
			<div v-for="item in mandatorListLocalMultiple" :key="item.value">
				<v-row dense v-show="item.value != '1111'">
					<v-col cols="12" md="3" >
						<div class="mandatorNmae">{{item.text}}: </div>
					</v-col>
					<v-col cols="12" md="3">
						<v-text-field
							:key="renderKey"
							v-model="item['transaction_fee']"
							counter
							maxlength="3"
							hint="Transaction fee by contract"
							label="Transaction fee in %"
							@keypress="numbersOnly"
							@change="renderKeyIncrease()"
						></v-text-field>
					</v-col>
				</v-row>
			</div>
		</div>
		<div v-show="!multipleFilter">
			<div>
				<v-row>
					<v-col cols="12" md="3" >
						<div class="mandatorNmae">{{txt.mandatorTxFee}}: </div>
					</v-col>
					<v-col cols="12" md="3">
						<v-text-field
							:key="renderKey"
							v-model="singleTranactionFee"
							counter
							maxlength="3"
							hint="Transaction will be applied for every selected mandator"
							label="Transaction fee in %"
							@keypress="numbersOnly"
							@change="renderKeyIncrease()"
						></v-text-field>
					</v-col>
				</v-row>
			</div>
		</div>
	</v-container>
</template>
<script>
export default {
	name: 'RevenueReportSumFil',
	props: {
		mandatorList: {
			type: Array,
		},
		multipleFilter: {
			type: Boolean,
			required: false,
		},
	},
	data() {
		return {
			renderKey: 0,
			mandatorListLocalSingle: '',
			mandatorListLocalMultiple: '',
			transactionFee: [],
			singleTranactionFee: '',
			txt: {
				mandatorTxFee: 'Tranasction fee',
			},
		}
	},
	watch: {
		mandatorList: {
			handler() {
				this.mandatorListLocalSingle = this.mandatorList
				this.mandatorListLocalMultiple = this.mandatorList
				this.renderKeyIncrease(this.renderKey + 1)
			},
		},
		multipleFilter: {
			handler() {
				this.renderKeyIncrease(this.renderKey + 1)
			},
		},
	},
	methods: {
		// credit to: https://codepen.io/esausilva/pen/EpzpRb
		// eslint-disable-next-line consistent-return
		numbersOnly(evt) {
			evt = (evt) || window.event
			const charCode = (evt.which) ? evt.which : evt.keyCode
			if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
				evt.preventDefault()
			} else {
				return true
			}
		},
		addTransactionFeeToEveryMandator() {
			// eslint-disable-next-line prefer-const
			for (let mandator of this.mandatorListLocalSingle) {
				// eslint-disable-next-line dot-notation
				mandator['transaction_fee'] = this.singleTranactionFee
			}
		},
		renderKeyIncrease() {
			if (this.multipleFilter) {
				this.$emit('update:mandatorList', this.mandatorListLocalMultiple)
			} else {
				this.addTransactionFeeToEveryMandator()
				this.$emit('update:mandatorList', this.mandatorListLocalSingle)
			}
			// eslint-disable-next-line no-return-assign
			return this.renderKey += 1
		},
	},
}

</script>

<style scoped>
.mandatorNmae{
	padding-top: 25px;
}
</style>
